import React from 'react'

import Grid from '../../../../components/pdf/Grid'
import Separator from '../../../../components/pdf/Separator'
import Text from '../../../../components/pdf/Text'
import Image from '../../../../components/pdf/Image'

const Header = () => {
  return (
    <>
      <Separator weight={0} />
      <Grid justify="space-between" align="center">
        <Image src="../../../../pdfs/grupokallas/grupokallas.png" maxWidth={80} ignoreFixedSize />
        <Text bold size={14}>
          {'Relatório de Auditoria Interna - Meio Ambiente'}
        </Text>
        <Text>{'F-SEG-46'}</Text>
      </Grid>
      <Separator weight={2} />
    </>
  )
}

export default Header
